import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-recreational',
  templateUrl: './product-recreational.component.html',
  styleUrls: ['./product-recreational.component.css']
})
export class ProductRecreationalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
